<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">ТТ Формат Shoppable Ads</div>
    <div class="markup__h markup__h_3">
      Данное размещение содержит - карточки товаров над роликом, кнопку внутри плеера для перехода.
    </div>

    <br>

    <div class="markup__h markup__h_2">
      <strong>Необходимые материалы для размещения:</strong>
    </div>
    <div class="attention attention_info">
      <p>Материалы для товарных карточек могут быть предоставлены как в формате отдельных папок со всеми материалами, так и в формате Excel, где изображения для товарных карточек будут выложены на файловые сервера по ссылкам. </p>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>
        <div class="markup__h markup__h_3">
          <strong>Видеоролик:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Формат: MP4</li>
          <li>Видеокодек: H.264</li>
          <li>Аудиокодек: MP3 или AAC</li>
          <li>Разрешение: рекомендуется не ниже Full HD 1080p</li>
          <li>Частота кадров: 30 в секунду</li>
          <li>Соотношение сторон: 16:9</li>
          <li>
            Хронометраж:
            <ul class="markup__ul markup__ul_nested">
              <li>оптимальный: 20 секунд</li>
              <li>максимальный: 30 секунд.</li>
            </ul>
          </li>
        </ul>
        <div class="attention attention_small-margin">
          <p>Размещение кодами VAST и VPAID недоступно в рамках данного формата</p>
        </div>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Кнопка:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Текст: до 10 символов</li>
          <li>Ссылка на посадочную страницу</li>
          <li>
            Внешний вид: дефолтный или кастомизированный. Есть возможность изменить внешний вид, использовав готовый дизайн клиента (необходимо предоставить готовую кнопоку в PNG или макеты PSD / FIGMA / AI), либо мы можем подготовить дизайн кнопки самостоятельно.
          </li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Карточки товаров:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Количество карточек: до 10</li>
          <li>
            <div>Изображение:</div>
            <ul class="markup__ul markup__ul_nested">
              <li>Соотношение сторон: 1:1</li>
              <li>Максимальный размер: 1000px : 1000px</li>
              <li>Формат: PNG</li>
              <li>Максимальный вес изображения: 1 МБ</li>
              <div class="html2pdf__page-break"/>
              <li>Не размещайте на изображениях тексты, кнопки и другие элементы. Для этого в объявлении есть специально предназначенные поля</li>
              <li>В названии файлов картинок необходимо указать пропорции изображения. Например, 1x1.png</li>
              <li>Все символы в названии файлов картинок должны быть прописаны <strong>только</strong> в английской раскладке</li>
            </ul>
          </li>
          <li>Заголовок: до 35 символов с пробелами</li>
          <li>Описание: до 25 символов с пробелами</li>
          <li>Текст кнопки: до 10 символов с пробелами</li>
          <li>Ссылки на посадочные страницы</li>
        </ul>
      </li>
    </ul>

    <marked-zone-atention></marked-zone-atention>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';
import markedZoneAtention from '@/components/documentation/markedZoneAtention.vue';

export default {
  name: 'shoppableAds',
  components: {
    markedZoneAtention,
  },
  data() {
    return {
      isMobile,
    };
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
